'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseAccessibilityTextArea = require('@bibliocommons/base-accessibility-text-area');

var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/OptInFeedback.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FEELINGS = ['positive', 'maybe', 'negative'];
var COMMENT_MAX_LENGTH = 3800;

var OptInFeedback = function (_BcReactComponent) {
  _inherits(OptInFeedback, _BcReactComponent);

  function OptInFeedback(props) {
    _classCallCheck(this, OptInFeedback);

    var _this = _possibleConstructorReturn(this, (OptInFeedback.__proto__ || Object.getPrototypeOf(OptInFeedback)).call(this, props));

    _this.state = {
      formData: {
        feeling: null,
        comment: ''
      }
    };

    _this.bindAll('handleFeelingSelect', 'handleSubmit', 'handleCommentChange');
    return _this;
  }

  _createClass(OptInFeedback, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      if (e) {
        e.preventDefault();
      }

      this.props.handleSubmit(this.props.bundle, _extends({}, this.state.formData, OptInFeedback.getBrowserInformation(), {
        category: this.props.feedbackCategory,
        optIn: true
      }));
    }
  }, {
    key: 'handleFeelingSelect',
    value: function handleFeelingSelect(e) {
      this.setState({
        formData: _extends({}, this.state.formData, {
          feeling: e.target.value
        })
      });
    }
  }, {
    key: 'handleCommentChange',
    value: function handleCommentChange(value) {
      this.setState({
        formData: _extends({}, this.state.formData, {
          comment: value
        })
      });
    }
  }, {
    key: 'renderFeelingOptions',
    value: function renderFeelingOptions() {
      var _this2 = this;

      return FEELINGS.map(function (feeling) {
        return _react2.default.createElement(
          'span',
          { key: feeling },
          _react2.default.createElement(
            'label',
            { className: 'radio-inline', htmlFor: 'overall-feeling-feel-' + feeling },
            _react2.default.createElement('input', {
              type: 'radio',
              name: 'overall-feeling',
              id: 'overall-feeling-feel-' + feeling,
              required: true,
              value: feeling,
              onChange: _this2.handleFeelingSelect,
              checked: _this2.state.formData.feeling === feeling,
              'aria-describedby': 'overall-feeling' }),
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: 'opt_in_feeling_' + feeling + '_' + _this2.props.bundle,
              defaultMessage: _this2.props.intl.formatMessage({ id: 'opt_in_feeling_' + feeling }) })
          ),
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            { id: 'overall-feeling' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'group_search_feedback_feeling' })
          )
        );
      });
    }
  }, {
    key: 'renderCommentBox',
    value: function renderCommentBox() {
      if (!this.state.formData.feeling) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'label',
          {
            htmlFor: 'feedback-message',
            id: 'feedback-message-label',
            className: 'control-label' },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_' + this.props.bundle + '_heading' })
        ),
        _react2.default.createElement(_baseAccessibilityTextArea2.default, {
          labelledById: 'feedback-message-label',
          describedById: 'feedback-message',
          value: this.state.formData.comment,
          required: true,
          maxLength: COMMENT_MAX_LENGTH,
          className: 'form-control',
          handleChange: this.handleCommentChange }),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          { id: 'feedback-message' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'group_search_feedback_additional_comments' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        { className: 'cp-opt-in-feedback', onSubmit: this.handleSubmit },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          this.renderFeelingOptions()
        ),
        _react2.default.createElement(
          'div',
          { className: 'opt-in-textarea' },
          this.renderCommentBox(),
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            { type: 'submit', className: 'feedback-submit-btn', isLoading: this.props.isLoading },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_submit_feedback_btn' })
          ),
          _react2.default.createElement(
            'a',
            {
              className: 'link-contextual',
              href: '#close-feedback-form',
              onClick: this.props.closeFeedbackForm },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }], [{
    key: 'getBrowserInformation',
    value: function getBrowserInformation() {
      return {
        screenResolution: window.screen.width + ' x ' + window.screen.height,
        viewportSize: window.outerWidth + ' x ' + window.outerHeight,
        referer: window.location.href,
        userAgent: window.navigator.userAgent
      };
    }
  }]);

  return OptInFeedback;
}(_baseBcReactComponent2.default);

OptInFeedback.propTypes = {
  feedbackCategory: _react2.default.PropTypes.string.isRequired,
  bundle: _react2.default.PropTypes.string.isRequired,
  handleSubmit: _react2.default.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape,
  closeFeedbackForm: _react2.default.PropTypes.func.isRequired,
  isLoading: _react2.default.PropTypes.bool
};

exports.default = (0, _reactIntl.injectIntl)(OptInFeedback);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-feedback/components/OptInFeedback.component.js
// module id = 1438
// module chunks = 1